import React, { useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HTMLFlipBook from "react-pageflip";

const Magazine1 = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const flipBookRef = useRef();
  const magazine = state?.magazine;
  const goToNextPage = () => {
    if (flipBookRef.current) {
      flipBookRef.current.pageFlip().flipNext(); // Call flipNext method
    }
  };

  const goToPreviousPage = () => {
    if (flipBookRef.current) {
      flipBookRef.current.pageFlip().flipPrev(); // Call flipPrev method
    }
  };
  if (!magazine) {
    return (
      <div className="container mt-5">
        <p>
          No magazine selected.{" "}
          <button onClick={() => navigate(-1)}>Go Back</button>
        </p>
      </div>
    );
  }
  return (
    <>
      <div className="container-fluid">
        {magazine === "4" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  size="stretch"
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  maxHeight={1200}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  {Array.from({ length: 92 }, (_, index) => (
                    <img
                      key={index}
                      src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/Magazine_2025_26/Magazine_2025_26_15_${index + 1}.jpg`}
                      alt={`Page ${index + 1}`}
                    />
                  ))}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}

        {magazine === "3" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-1.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-2.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-3.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-4.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-5.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-6.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-7.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-8.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-9.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-10.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-11.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-12.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-13.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-14.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-15.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-16.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-17.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-18.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-19.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-20.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-21.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-22.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-23.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-24.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-25.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-26.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-27.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-28.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-29.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-30.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-31.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-32.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-33.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-34.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-35.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-36.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-37.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-38.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-39.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-40.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-41.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-42.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-43.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-44.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-45.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-46.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-47.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-48.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-49.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-50.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-51.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-52.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-53.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-54.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-55.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-56.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-57.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-58.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-59.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-60.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-61.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-62.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-63.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-64.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-65.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-66.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-67.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-68.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-69.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-70.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-71.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-72.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-73.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-74.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-75.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-76.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-77.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-78.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-79.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-80.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-81.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-82.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-83.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-84.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-85.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-86.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-87.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-88.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-89.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-90.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-91.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-92.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-93.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-94.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-95.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-96.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-97.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-98.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-99.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-100.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-101.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-102.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-103.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-24-25-jun/maria-teresa-unzu-104.jpg"
                      alt="Page 20"
                    />
                  </div>

                  {/* Add more pages as required */}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}

        {magazine === "2" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/1.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/2.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/3.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/4.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/5.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/6.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/7.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/8.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/9.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/10.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/11.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/12.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/13.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/14.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/15.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/16.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/17.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/18.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/19.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/20.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/21.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/22.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/23.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/24.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/25.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/26.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/27.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/28.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/29.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/30.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/31.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/32.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/33.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/34.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/35.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/36.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/37.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/38.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/39.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/40.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/41.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/42.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/43.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/44.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/45.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/46.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/47.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/48.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/49.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/50.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/51.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/52.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/53.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/54.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/55.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/56.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/57.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/58.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/59.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/60.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/61.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/62.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/63.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/64.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/65.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/66.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/67.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/68.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/69.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/70.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/71.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/72.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/73.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/74.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/75.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/76.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/77.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/78.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/79.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/80.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/81.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/82.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/83.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/84.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/85.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/86.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/87.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/88.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/89.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/90.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/91.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/92.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/93.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/94.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/95.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/96.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/97.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/98.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/99.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/100.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/101.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/102.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/103.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/104.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine-2024-2025/105.jpg"
                      alt="Page 20"
                    />
                  </div>

                  {/* Add more pages as required */}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {magazine === "1" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/1.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/2.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/3.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/4.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/5.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/6.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/7.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/8.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/9.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/10.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/11.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/12.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/13.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/14.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/15.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/16.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/17.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/18.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/19.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/20.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/21.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/22.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/23.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/24.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/25.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/26.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/27.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/28.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/29.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/30.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/31.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/32.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/33.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/34.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/35.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/36.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/37.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/38.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/39.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/40.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/41.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/42.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/43.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/44.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/45.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/46.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/47.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/48.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/49.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/50.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/51.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/52.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/53.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/54.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/55.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/56.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/57.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/58.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/59.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/60.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/61.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/62.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/63.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/64.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/65.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/66.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/67.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/68.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/69.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/70.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/71.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/72.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/73.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/74.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/75.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/76.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/77.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/78.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/79.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/80.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/81.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/82.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/83.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/84.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/85.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/86.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/87.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/88.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/89.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/90.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/91.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/92.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/93.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/94.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/95.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/96.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/97.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/98.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/99.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/100.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/101.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/102.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/103.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/104.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/105.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/106.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/107.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/108.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/109.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/110.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/111.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/112.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/113.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/114.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/115.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/116.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/117.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/118.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/119.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/120.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/121.jpg"
                      alt="Page 21"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/122.jpg"
                      alt="Page 22"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/123.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/124.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/125.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/126.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/127.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/128.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/129.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/130.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/131.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/132.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/133.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/134.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/135.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/136.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/137.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/138.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/139.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/140.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/141.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/142.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/143.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/144.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/145.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/146.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/147.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/148.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/149.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/150.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/151.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/152.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/153.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/154.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/155.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/156.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/157.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/158.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/159.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/160.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/161.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/162.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/163.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/164.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/165.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/166.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/167.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/168.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/169.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/170.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/171.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/172.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/173.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/174.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/175.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/176.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/177.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/178.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/179.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/180.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/181.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/182.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/183.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/184.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/185.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/186.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/187.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/188.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/189.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/190.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/191.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/192.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/193.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/194.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/195.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/196.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/197.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/198.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/199.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine/200.jpg"
                      alt="Page 20"
                    />
                  </div>

                  {/* Add more pages as required */}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {magazine === "12" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-1 copy.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-2 copy.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-3 copy.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-4 copy.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-5 copy.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-6 copy.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-7 copy.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-8 copy.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-9 copy.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-10 copy.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-11 copy.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-12 copy.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-13 copy.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-14 copy.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-15 copy.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-16 copy.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-17 copy.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-18 copy.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-19 copy.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-20 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-21 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-22 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-23 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-24 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-25 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-26 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-27 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-28 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-29 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-30 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-31 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-32 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-33 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-34 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-35 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-36 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-37 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-38 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-39 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-40 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-41 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-42 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-43 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-44 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-45 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-46 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-47 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-48 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-49 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-50 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-51 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-52 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-53 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-54 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-55 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-56 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-57 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-58 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-59 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-60 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-61 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-62 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-63 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-64 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-65 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-66 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-67 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-68 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-69 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-70 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-71 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-72 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-73 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-74 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-75 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-76 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-77 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-78 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-79 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-80 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-81 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-82 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-83 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-84 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-85 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-86 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-87 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-88 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-89 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-90 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-91 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-92 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-93 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-94 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-95 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-96 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-97 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-98 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-99 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-100 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2022-23/Nirmalight-Vol-12-101 copy.jpg"
                      alt="Page 20"
                    />
                  </div>

                  {/* Add more pages as required */}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {magazine === "11" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-1 copy.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-2 copy.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-3 copy.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-4 copy.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-5 copy.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-6 copy.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-7 copy.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-8 copy.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-9 copy.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-10 copy.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-11 copy.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-12 copy.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-13 copy.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-14 copy.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-15 copy.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-16 copy.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-17 copy.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-18 copy.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-19 copy.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-20 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-21 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-22 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-23 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-24 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-25 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-26 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-27 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-28 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-29 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-30 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-31 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-32 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-33 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-34 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-35 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-36 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-37 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-38 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-39 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-40 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-41 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-42 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-43 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-44 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-45 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-46 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-47 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-48 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-49 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-50 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-51 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-52 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-53 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-54 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2014-15/Nirmalight-Vol-6-55 copy.jpg"
                      alt="Page 20"
                    />
                  </div>

                  {/* Add more pages as required */}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {magazine === "10" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-1 copy.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-2 copy.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-3 copy.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-4 copy.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-5 copy.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-6 copy.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-7 copy.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-8 copy.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-9 copy.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-10 copy.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-11 copy.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-12 copy.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-13 copy.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-14 copy.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-15 copy.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-16 copy.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-17 copy.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-18 copy.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-19 copy.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-20 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-21 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-22 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-23 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-24 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-25 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-26 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-27 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-28 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-29 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-30 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-31 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-32 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-33 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-34 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-35 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-36 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-37 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-38 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-39 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-40 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-41 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-42 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-43 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-44 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-45 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-46 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-47 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2013-14/Nirmalight-vol-5-48 copy.jpg"
                      alt="Page 20"
                    />
                  </div>

                  {/* Add more pages as required */}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {magazine === "9" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-1 copy.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-2 copy.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-3 copy.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-4.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-5.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-6.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-7.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-8.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-9.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-10 copy.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-11 copy.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-12 copy.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-13 copy.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-14 copy.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-15 copy.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-16 copy.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-17 copy.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-18 copy.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-19 copy.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-20 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-21 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-22 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-23 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-24 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-25 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-26 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-27 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-28 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-29 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-30 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-31 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-32 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-33 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-34 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-35 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-36.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-37.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-38.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-39.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-40.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-41.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-42.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-43.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-44.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2011-12/Nirmalight-Vol-4-45.jpg"
                      alt="Page 20"
                    />
                  </div>

                  {/* Add more pages as required */}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {magazine === "8" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-1 copy.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-2 copy.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-3 copy.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-4 copy.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-5 copy.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-6 copy.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-7.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-8.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-9.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-10 copy.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-11 copy.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-12 copy.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-13 copy.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-14 copy.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-15 copy.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-16 copy.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-17 copy.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-18 copy.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-19 copy.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-20 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-21 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-22 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-23 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-24 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-25 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-26 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-27 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-28 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-29 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-30 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-31 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-32 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-33 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-34 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-35 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-36 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-37 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-38 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-39 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-40 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-41 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-42 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-43 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2010-11/Nirmalight-Vol-3-44 copy.jpg"
                      alt="Page 20"
                    />
                  </div>

                  {/* Add more pages as required */}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {magazine === "7" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-1 copy.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-2 copy.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-3 copy.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-4 copy.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-5 copy.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-6 copy.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-7 copy.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-8 copy.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-9 copy.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-10 copy.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-11 copy.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-12 copy.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-13 copy.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-14 copy.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-15 copy.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-17 copy.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-18 copy.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-19 copy.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-20 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-21 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-22 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-23 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-24 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-25 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-26 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-27 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-28 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-29 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-30 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-31 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-32 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-33 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-34 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-35 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-36 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-37 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-38 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-39 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-40 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-41 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-42 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-43 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-44 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-45 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2009-10/Nirmalight-Vol-2-46 copy.jpg"
                      alt="Page 20"
                    />
                  </div>

                  {/* Add more pages as required */}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {magazine === "6" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-0.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-1 copy.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-2 copy.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-3 copy.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-4 copy.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-5 copy.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-6 copy.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-7 copy.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-8 copy.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-9 copy.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-10 copy.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-11 copy.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-12 copy.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-13 copy.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-14 copy.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-15 copy.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-16 copy.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-17 copy.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-18 copy.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-19 copy.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-20 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-21 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-22 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-23 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-24 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-25 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-26 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-27 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-28 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-29 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-30 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-31 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-32 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-33 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-34 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-35 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-36 copy.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine2008-09/Nirmalight-Vol-1-images-37 copy.jpg"
                      alt="Page 20"
                    />
                  </div>

                  {/* Add more pages as required */}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {magazine === "5" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir1.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir2.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir3.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir4.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir5.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir6.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir7.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir8.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir9.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir10.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir11.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir12.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir13.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir14.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir15.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir16.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir17.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir18.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir19.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir20.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir21.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir22.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir23.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir24.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir25.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir26.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir27.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir28.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir29.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir30.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir31.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir32.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir33.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir34.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir35.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir36.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir37.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir38.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir39.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir40.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir41.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir42.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir43.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir44.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir45.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir46.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir47.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir48.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir49.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir50.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir51.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir52.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir53.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir54.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir55.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir56.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir57.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir58.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir59.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir60.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir61.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir62.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir63.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir64.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir65.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir66.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir67.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir68.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir69.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir70.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir71.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir72.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir73.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir74.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir75.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir76.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir77.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir78.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir79.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir80.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir81.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir82.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir83.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir84.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir85.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir86.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir87.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir88.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir89.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir90.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir91.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir92.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir93.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir94.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir95.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir96.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir97.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir98.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir99.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir100.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir101.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir102.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir103.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir104.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir105.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir106.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir107.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/magazine1963-2013/Golden-Jubllee-Souvenir108.jpg"
                      alt="Page 20"
                    />
                  </div>

                  {/* Add more pages as required */}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {magazine === "13" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-1.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-2.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-3.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-4.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-5.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-6.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-7.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-8.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-9.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-10.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-11.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-12.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-13.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-14.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-15.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-16.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-17.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-18.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-19.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-20.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-21.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-22.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-23.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-24.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-25.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-26.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-27.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-28.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-29.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-30.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-31.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-32.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-33.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-34.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-35.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-36.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-37.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-38.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-39.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-40.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-41.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-42.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-43.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-44.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-45.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-46.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-47.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-48.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-49.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-50.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-51.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-52.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-7-53.jpg"
                      alt="Page 20"
                    />
                  </div>
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {magazine === "14" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-1.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-2.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-3.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-4.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-5.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-6.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-7.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-8.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-9.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-10.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-11.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-12.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-13.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-14.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-15.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-16.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-17.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-18.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-19.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-20.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-21.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-22.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-23.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-24.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-25.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-26.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-27.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-28.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-29.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-30.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-31.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-32.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-33.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-34.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-35.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-36.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-37.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-38.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-39.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-40.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-41.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-42.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-43.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-44.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-45.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-46.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-47.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-48.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-49.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-50.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-51.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-52.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-53.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-54.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-55.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-56.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-57.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-58.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-59.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-60.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-61.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-62.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-63.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-64.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-65.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-8-66.jpg"
                      alt="Page 20"
                    />
                  </div>

                  {/* Add more pages as required */}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {magazine === "15" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-1.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-2.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-3.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-4.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-5.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-6.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-7.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-8.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-9.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-10.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-11.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-12.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-13.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-14.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-15.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-16.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-17.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-18.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-19.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-20.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-21.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-22.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-23.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-24.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-25.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-26.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-27.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-28.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-29.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-30.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-31.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-32.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-33.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-34.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-35.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-36.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-37.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-38.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-39.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-40.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-41.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-42.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-43.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-44.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-45.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-46.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-47.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-48.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-49.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-50.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-51.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-52.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-53.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-54.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-55.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-56.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-9-57.jpg"
                      alt="Page 20"
                    />
                  </div>

                  {/* Add more pages as required */}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {magazine === "16" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-1.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-2.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-3.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-4.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-5.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-6.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-7.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-8.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-9.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-10.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-11.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-12.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-13.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-14.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-15.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-16.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-17.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-18.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-19.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-20.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-21.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-22.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-23.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-24.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-25.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-26.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-27.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-28.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-29.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-30.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-31.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-32.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-33.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-34.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-35.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-36.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-37.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-38.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-39.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-40.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-41.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-42.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-43.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-44.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-45.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-46.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-47.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-48.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-49.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-50.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-51.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-52.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-53.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-54.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-55.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-56.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-57.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-58.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-59.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-60.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-61.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-62.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-63.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-64.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-65.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-66.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-10-67.jpg"
                      alt="Page 20"
                    />
                  </div>

                  {/* Add more pages as required */}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {magazine === "17" && (
          <div className="row inner-content">
            <div className="col-md-12">
              <div className="flipOpen">
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={600}
                  height={800}
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  mobileScrollSupport={true}
                  showCover={true}
                  useMouseEvents={true}
                  className="flipPageComponent"
                  pageBackground="rgb(255, 255, 255)"
                  uncutPages={true}
                >
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-1.jpg"
                      alt="Page 1"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-2.jpg"
                      alt="Page 2"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-3.jpg"
                      alt="Page 3"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-4.jpg"
                      alt="Page 4"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-5.jpg"
                      alt="Page 5"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-6.jpg"
                      alt="Page 6"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-7.jpg"
                      alt="Page 7"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-8.jpg"
                      alt="Page 8"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-9.jpg"
                      alt="Page 9"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-10.jpg"
                      alt="Page 10"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-11.jpg"
                      alt="Page 11"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-12.jpg"
                      alt="Page 12"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-13.jpg"
                      alt="Page 13"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-14.jpg"
                      alt="Page 14"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-15.jpg"
                      alt="Page 15"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-16.jpg"
                      alt="Page 16"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-17.jpg"
                      alt="Page 17"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-18.jpg"
                      alt="Page 18"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-19.jpg"
                      alt="Page 19"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-20.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-21.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-22.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-23.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-24.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-25.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-26.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-27.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-28.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-29.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-30.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-31.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-32.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-33.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-34.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-35.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-36.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-37.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-38.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-39.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-40.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-41.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-42.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-43.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-44.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-45.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-46.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-47.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-48.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-49.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-50.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-51.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-52.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-53.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-54.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-55.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-56.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-57.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-58.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-59.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-60.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-61.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-62.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-63.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-64.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-65.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-66.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-67.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-68.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-69.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-70.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-71.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-72.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-73.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-74.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-75.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-76.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-77.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-78.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-79.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-80.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-81.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-82.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-83.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-84.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-85.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-86.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-87.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-88.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-89.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-90.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-91.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-92.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-93.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-94.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-95.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-96.jpg"
                      alt="Page 20"
                    />
                  </div>
                  <div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/vol-2025/nirmalight-vol-11-97.jpg"
                      alt="Page 20"
                    />
                  </div>

                  {/* Add more pages as required */}
                </HTMLFlipBook>
              </div>
              <div className="navigation-buttons">
                <button onClick={goToPreviousPage} className="btn btn-primary">
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button onClick={goToNextPage} className="btn btn-primary">
                  <i class="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Magazine1;
